
import {Component, Vue} from "vue-property-decorator";
import $ from "jquery";
import {EXPERIMENT_ESTHER_ADS} from "@/views/Experiments";

@Component
export default class HomeAds4 extends Vue {
  private adsSidebar300: string;
  private adsSidebarTall: string;
  private adsFooterSm: string;
  private adsFooterMd: string;
  private adsFooterLg: string;
  private adsSection2Footer: string;
  private adsSection2Sidebar: string;
  private adsSection3Footer: string;
  private adsSection3Tall: string;
  private adsSection4Tall: string;
  private isEstherAds = false;

  public mounted() {
    this.onMounted();
  }

  private innerHtml(id: string) {
    const el = document.getElementById(id);
    if (el) {
      console.log("Found ads block " + id);
      const innerHtml = el.innerHTML;
      el.remove();
      return innerHtml;
    } else {
      console.log("Did not find ads block " + id);
      return "";
    }
  }

  private insertAds(id: string, adsHtml: string): number {
    if (this.isDisplayed(`#${id}`)) {
      const el = document.getElementById(id);
      if (el) {
        const w = el.getBoundingClientRect().width;
        if (w > 0) {
          el.innerHTML = adsHtml;
          console.log("Inserted ads block " + id);
        } else {
          console.log("Did not insert ads block " + id + " because width is 0");
        }
      }
      return 1;
    } else {
      return 0;
    }
  }
  private onMounted() {
    this.adsSidebar300 = this.innerHtml('ads-sidebar-300-tmpl');
    this.adsSidebarTall = this.innerHtml('ads-sidebar-tall-tmpl');
    // this.adsSidebarTall = this.isEstherAds
    //     ? document.getElementById("ads-sidebar-esther-tmpl").innerHTML
    //     : document.getElementById('ads-sidebar-tall-tmpl').innerHTML;
//this.adsSidebarTall = document.getElementById('ads-sidebar-tall-tmpl').innerHTML;
//    document.getElementById('ads-sidebar-tall-tmpl').remove();
    this.adsFooterSm = this.innerHtml('ads-footer-sm-tmpl');
    this.adsFooterMd = this.innerHtml('ads-footer-md-tmpl');
    this.adsFooterLg = this.innerHtml('ads-footer-lg-tmpl');
    this.adsSection2Sidebar = this.innerHtml('ads-section2-tall-tmpl');
    this.adsSection2Footer = this.innerHtml('ads-section2-footer-tmpl');
    this.adsSection3Footer = this.innerHtml('ads-section3-footer-tmpl');
    this.adsSection3Tall = this.innerHtml('ads-section3-tall-tmpl');
    this.adsSection4Tall = this.innerHtml('ads-section4-tall-tmpl');
    window.adsbygoogle = window.adsbygoogle || [];

    let displayedCount = 0;
    displayedCount += this.insertAds('ads-sidebar-tall', this.adsSidebarTall);
    //displayedCount += this.insertAds('ads-sidebar-300', this.adsSidebar300);
    // if (this.isDisplayed('#ads-footer-sm')) {
    //   document.getElementById('ads-footer-sm').innerHTML = this.adsFooterSm;
    //   displayedCount++;
    // }
    // if (this.isDisplayed('#ads-footer-md')) {
    //   document.getElementById('ads-footer-md').innerHTML = this.adsFooterMd;
    //   displayedCount++;
    // }
    // if (this.isDisplayed('#ads-footer-lg')) {
    //   document.getElementById('ads-footer-lg').innerHTML = this.adsFooterLg;
    //   displayedCount++;
    // }
    displayedCount += this.insertAds('ads-section2-sidebar-tall', this.adsSection2Sidebar);
    // displayedCount += this.insertAds('ads-section2-footer', this.adsSection2Footer);
    // displayedCount += this.insertAds('ads-section3-footer', this.adsSection3Footer);
    displayedCount += this.insertAds('ads-section3-sidebar-tall', this.adsSection3Tall);
    displayedCount += this.insertAds('ads-section4-sidebar-tall', this.adsSection4Tall);
    // if (this.isDisplayed('#ads-section2-footer')) {
    //   document.getElementById('ads-section2-footer').innerHTML = this.adsSection2Footer;
    //   displayedCount++;
    // }
    // if (this.isDisplayed('#ads-section3-footer')) {
    //   document.getElementById('ads-section3-footer').innerHTML = this.adsSection3Footer;
    //   displayedCount++;
    // }
    try {
      console.log("We have " + displayedCount + " ad units to insert:")
      window.adsbygoogle = window.adsbygoogle || [];
      const slots = document.querySelectorAll('ins.adsbygoogle');
      for (let i = 0; i < slots.length; i++) {
        console.log("Inserting ad unit " + i);
        try { window.adsbygoogle.push({ google_ad_channel: '9855342662' }); }
        catch (e) {
          console.log("Error pushing ad unit " + slots[i]["data-ad-slot"] + ": " + e);

        }
      }
      console.log(`Inserted ${displayedCount} ad units`);
      // window.adsbygoogle.push({});
      // window.adsbygoogle.push({});
      // window.adsbygoogle.push({});
      // window.adsbygoogle.push({});
    } catch (e) {
      console.log(e);
    }
  }

  private isDisplayed(selector: string): boolean {
    const displayCss = $(selector).css("display");
    return displayCss != null && displayCss !== "none";
  }

}
